import styled from "styled-components";

export const Header = styled.header`
  padding: 10px 0;
  background: #ffffff;
  width: 100%;
`;

export const RightSideHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  .ant-btn-link {
    margin-left: 15px;
    border: 0;
    background: transparent;
    height: 20px;
    svg {
      color: var(--dark-grey-70);
      height: 20px;
      width: 20px;
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }

  > div:not(.avatar-placeholder) {
    margin-left: 20px;
    line-height: 22px;

    display: flex;
    flex-direction: column;
    font-size: 16px;

    span {
      color: var(--dark-grey-70);
    }

    a {
      color: var(--light-orange);

      &:hover {
        opacity: 0.8;
      }
    }
  }
`;

export const Content = styled.main`
  max-width: 1120px;
  margin: 64px auto;

  display: flex;
`;

export const Section = styled.section`
  margin-top: 48px;

  > strong {
    color: #999591;
    font-size: 20px;
    line-height: 26px;
    display: block;
    border-bottom: 1px solid #3e3b47;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  > p {
    color: #999591;
    font-weight: 400;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;

  > img {
    width: 60%;
  }
`;

export const PageContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
